(function (angular) {
  "use strict";

  angular.module("app").controller("myTicketsController", myTicketsController);

  myTicketsController.$inject = [
    "eventOrdersPayload",
    "EventOrdersApi",
    "$rootScope",
    "$scope",
  ];

  function myTicketsController(
    eventOrdersPayload,
    EventOrdersApi,
    $rootScope,
    $scope,
  ) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.eventOrders = angular.copy(eventOrdersPayload);
    vm.filters = {
      user_id: $rootScope.thisUser.id,
      with: "event",
      page: 1,
      sort: "starts_at",
      order: "asc",
      event_ends_at_from: new Date(),
    };

    // methods
    vm.getEventOrders = getEventOrders;
    vm.showPastTickets = showPastTickets;
    vm.hidePastTickets = hidePastTickets;

    vm.showingCalendar = false;
    $scope.toggleCalendar = function () {
      vm.showingCalendar = !vm.showingCalendar;
    };
    /**
     * Retrieves the user's events from the API
     * @return {void}
     */
    function getEventOrders() {
      vm.isLoading = true;

      EventOrdersApi.get(
        vm.filters,
        function handleGetEventOrdersResponse(response) {
          vm.eventOrders = response;
          vm.isLoading = false;
        },
        function handleGetEventOrdersError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Show user's past tickets
     * @return {void}
     */
    function showPastTickets() {
      vm.filters.event_ends_at_from = false;
      vm.getEventOrders();
    }

    /**
     * Hide user's past tickets
     * @return {void}
     */
    function hidePastTickets() {
      vm.filters.event_ends_at_from = new Date();
      vm.getEventOrders();
    }

    // init
    vm.eventOrders.data = [];
    angular.forEach(eventOrdersPayload.data, function (eventOrder) {
      vm.eventOrders.data.push(new EventOrdersApi(eventOrder).transform());
    });
  }
})(angular);
